export default __webpack_public_path__ + "static/media/pypi.88d0c97e.png";